import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is Business Automation?",
      answer: "Business Automation refers to the use of software, tools, and AI to automate repetitive tasks and processes, reducing manual effort and improving efficiency.",
    },
    {
      question: "Why is Business Automation important?",
      answer: "Business Automation is important because it saves time, minimizes human errors, and streamlines operations, helping businesses grow faster and more efficiently.",
    },
    {
      question: "What are the benefits of Business Automation?",
      answer: "The key benefits of Business Automation include: 1. Time and cost savings , 2. Increased productivity , 3. Improved accuracy , 4. Faster decision-making , 5. Better customer experience",
    },
    {
      question: "Which industries can use Business Automation?",
      answer: "Business Automation can be used across various industries such as: 1. E-commerce , 2. Healthcare , 3. Finance , 4. Real estate , 5. Digital marketing",
    },
    {
      question: "How can I implement Business Automation in my business?",
      answer: "To implement Business Automation, identify repetitive tasks, choose the right automation tools (like CRM, AI tools, and workflow software), and gradually automate your business processes.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;